/**
 * Event type master data keys
 */
export const EVENT_TYPE_KEYS = {
  // "Arrived at parcel store" event
  ARRIVED_AT_PARCEL_STORE: 'G32',
};
